import { DatePicker, Form } from 'antd'
import { FC, useContext, useRef } from 'react'
import { EditableCellCtx } from '../../../../../components/editable-cell/editable-cell'
import { outputDateFormat } from '../../../../../constants/constants'

const ShipmentClientDeliveryDate: FC = () => {
    const ctx = useContext(EditableCellCtx)
    const changedRef = useRef(false)

    return (
        <Form.Item name='clientDeliveryDate' noStyle>
            <DatePicker
                autoFocus
                format={outputDateFormat}
                style={{ width: '100%' }}
                onChange={() => {
                    changedRef.current = true
                    setTimeout(() => ctx.onBlur(), 0)
                }}
                onOpenChange={open => {
                    if (open) {
                        changedRef.current = false
                        return
                    }
                    if (!open && !changedRef.current) {
                        ctx.onCancel()
                    }
                }}
            />
        </Form.Item>
    )
}

export default ShipmentClientDeliveryDate
